import { Box } from '@chakra-ui/react'
import { FlexRow } from '@components'
import { useTranslation } from 'react-i18next'

export const LoadProfileDetailsGraphLegend = ({ isQuarterly, isOnlyOneDay }) => {
  const { t } = useTranslation()
  return (
    <FlexRow gap={4}>
      {/* {isQuarterly && (
        <FlexRow alignItems="center" gap="4px">
          <FlexRow alignItems="center" fontSize={13}>
            <Box width={3} height="2px" backgroundColor="#EF4444" marginRight={2} />
            {t('common.annual_peak_load')}
          </FlexRow>
          <BaseTooltip width={'16px'} height={'16px'} label={t('ember.peak_power_current_year')} />
        </FlexRow>
      )} */}

      <FlexRow alignItems='center' fontSize={13}>
        <Box width={3} height='4px' borderRadius={'4px'} backgroundColor='#008236' marginRight={2} />
        {isQuarterly ? t('messstellen.power') : t('messstellen.consumption')}
      </FlexRow>

      {/* {isOnlyOneDay && isQuarterly && (
        <FlexRow alignItems="center" fontSize={13}>
          <Box width={3} height="2px" borderRadius={'4px'} backgroundColor="#BCBCBC" marginRight={2} />
          Erwarteter Verbrauch
        </FlexRow>
      )} */}
    </FlexRow>
  )
}
